import '@/styles/vue.css.scss';
import { defineCustomElement } from 'vue';
import { createPinia, setActivePinia } from 'pinia';
import { ensureSentryInit } from '@/services/sentry';

ensureSentryInit();
const pinia = createPinia();
setActivePinia(pinia);

const componentLoaders = {
  ...import.meta.glob('@/components/**/*.ce.vue'),
  ...import.meta.glob('@/features/**/*.ce.vue'),
};

const moduleLoaders = new Map();

for (const [key, loader] of Object.entries(componentLoaders)) {
  const name = key.split(/[\\/]/).pop().toLowerCase(),
    tagName = name.slice(0, name.indexOf('.'));

  moduleLoaders.set(tagName, loader);
}

const pendingDefinitions = new Map();

// Loads and registers a Custom Element on demand instead of bundling all of them eagerly
const defineCustomElementFor = (tagName) => {
  const customTagName = 'pk-custom-' + tagName;

  if (window.customElements.get(customTagName)) return Promise.resolve();

  if (!pendingDefinitions.has(tagName)) {
    const loader = moduleLoaders.get(tagName);

    if (!loader) return Promise.resolve();

    pendingDefinitions.set(
      tagName,
      loader()
        .then((module) => {
          window.customElements.define(customTagName, defineCustomElement(module.default));
        })
        .catch((error) => {
          pendingDefinitions.delete(tagName);
          console.error('ERROR:', error);
        })
    );
  }

  return pendingDefinitions.get(tagName);
};

// Only load the Custom Elements that are actually present on the current page
for (const tagName of moduleLoaders.keys()) {
  if (document.getElementsByTagName('pk-custom-' + tagName).length) {
    defineCustomElementFor(tagName);
  }
}

const PK_CE = {};

PK_CE.pkShowCustomModal = async (tagName = '', url = '', params = {}) => {
  var existing = document.getElementsByTagName('pk-custom-' + tagName),
    tag = document.createElement('pk-custom-' + tagName);

  // ^ IF - If element is not mounted yet -> append element to DOM and set attribute
  // ^ ELSE - To Mount element after closing delete html tag and create new element with new data
  if (!existing.length) {
    tag.setAttribute('params', JSON.stringify(params));
    tag.setAttribute('url', url);
    document.body.appendChild(tag);
  } else if (existing && existing[0].hasAttribute('url')) {
    document.body.removeChild(existing[0]);
    tag.setAttribute('params', JSON.stringify(params));
    tag.setAttribute('url', url);
    document.body.appendChild(tag);
  }

  await defineCustomElementFor(tagName);
};

window.PK_CE = PK_CE;
